import React from 'react';
import SelectRecipientModal from '../../../../dashboard/components/Modals/SelectRecipientModal';
import ManageDistList from '../../../../dashboard/components/Modals/ManageDistList';
import { useDashboardContext } from '../../../../dashboard/context';
import GroupDetailsUpdations from '../../../../dashboard/components/Modals/GroupDetailsUpations';
import PropTypes from 'prop-types';
import { useAssignmentContext } from '../../../context';
import { useEffect } from 'react';

const ShareMenuModal = ({ assignmentId }) => {
  const { allAssignmentShareUsers, setAllAssignmentShareUsers } = useDashboardContext();
  const selectedAassignment = useAssignmentContext();
  const [isLoader, setIsLoader] = React.useState(false);
  const { assignedData, setAssignedData, setAssignmentId, setAssignedDataStatus } =
    useAssignmentContext();

  useEffect(() => {
    setIsLoader(false);
  }, [allAssignmentShareUsers]);

  return (
    <>
      <SelectRecipientModal
        assignmentId={assignmentId.length > 0 ? assignmentId : selectedAassignment.assignmentIdSend}
        assignments={true}
        title={'Send Copy of Selected Assignments'}
        saveButton={'Send Copy'}
        addRemoveListHeader={'Send Copy to'}
        addByLabel={'Add by Groups'}
        manageButton={'Select/Manage Groups'}
        dataArray={allAssignmentShareUsers}
        setDataArray={setAllAssignmentShareUsers}
        resetGridData={setAssignedDataStatus}
        resetSelectedAssignment={assignedData.length > 0 ? setAssignedData : setAssignmentId}
        loader={isLoader}
        setLoader={setIsLoader}
      />
      <GroupDetailsUpdations assignments={true} />
      <ManageDistList
        assignments={true}
        title={'Manage Groups'}
        label={'Enter the name for the group'}
        createButton={'Create Group'}
        firstColumnTitle={'Group Name'}
      />
    </>
  );
};

ShareMenuModal.propTypes = {
  assignmentId: PropTypes.array.isRequired
};

export default ShareMenuModal;
